import Vue from 'vue';
import ChatRoom from "./chatroom.vue";
import ChatRoomExamine from "./chatroomexamine.vue";
import tim from './tim';
import store from './store/index';
import TIM from 'tim-js-sdk';
import Avatar from './components/avatar.vue';
import VueAlert from "@vuejs-pt/vue-alert";
import './assets/icon/iconfont.css'
import './assets/icon/tim.css'

Vue.prototype.tim = tim;
Vue.prototype.TIM = TIM;
Vue.prototype.$store = store;
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。

Vue.use(VueAlert);

Vue.component('avatar', Avatar);
Vue.component('chat-room', ChatRoom);
Vue.component('chat-examine', ChatRoomExamine);
